import RegisterEmail from './RegisterEmailContainer';

export default RegisterEmail;